import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Redirect } from 'react-router-dom';

import { currentUserIsManager, getBrowserName, setCookie, getCookie, isUnsupportedDevice, isUnsupportedBrowser } from '../../util';

import { getIcon, getBrowserIcon } from '../../util/icons';

class WelcomeModal extends Component{

  state = {
    currentStep: 1,
    welcomeComplete: false,
    visible: false,
  }

  componentWillMount(){
    // console.log('getBrowserName: ', getBrowserName());
    // console.log('getCookie(velocity_v0_manager_welcome_completed)');
    // console.log(getCookie('velocity_v0_manager_welcome_completed'));
    // console.log('currentUserIsManager: ', currentUserIsManager() ? 'yes' : 'no');

    const TEST_WELCOME_MODALS = false;

    if(TEST_WELCOME_MODALS){
      this.setState({
        visible: true
      });
    }
    else{
      if(currentUserIsManager() && getCookie('velocity_v0_manager_welcome_completed') !== 'YES'){
        this.setState({
          visible: true
        });
      }
      else if(!currentUserIsManager() && getCookie('velocity_v0_rep_welcome_completed') !== 'YES'){
        this.setState({
          visible: true
        });
      }
    }
  }

  finishWelcome(){
    //set welcome completed in cookies!
    setCookie((currentUserIsManager() ? 'velocity_v0_manager_welcome_completed' : 'velocity_v0_rep_welcome_completed'), 'YES');

    //then set visible to false and redirect
    this.setState({
      visible: false,
      welcomeComplete: true
    });
  }

  resetScroll(){
    console.log('resetting scroll!');
    //this.container.scrollTop = '0px';
    window.scrollTo(0, 0);
  }

  prev(){
    this.setState({
      currentStep: this.state.currentStep - 1
    });
    setTimeout(this.resetScroll.bind(this), 50);
  }

  next(){
    this.setState({
      currentStep: this.state.currentStep + 1
    });
    setTimeout(this.resetScroll.bind(this), 50);
  }

  renderQuarterlyPreview(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon active">{getIcon('talents')}</div>
            <div className="message-icon">{getIcon('sprint')}</div>
            <div className="message-icon">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 1: Talent Evaluation (Quarterly)</h2>
          <p>The first step of the Velocity Sales process is to get a sense of the strengths and weaknesses of your salespeople. Both you and your reps will complete a talent evaluation. This will set a baseline for behaviors and sales skills which they can improve.</p>
          <p>Having a sense of where their talents lie will also help you select which areas you'd like your team to focus on improving each quarter.</p>
        </div>
      )
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon active">{getIcon('talents')}</div>
            <div className="message-icon">{getIcon('sprint')}</div>
            <div className="message-icon">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 1: Talent Evaluation (Quarterly)</h2>
          <p>The first step of the Velocity Sales process is to get a sense of where your strengths and weaknesses are. Both you and your manager will complete a talent evaluation. This will set a baseline for behaviors and sales skills where you can improve.</p>
          <p>Having a sense of where your talents lie will also help you and your manager select which areas you'd like to focus on improving each quarter.</p>
        </div>
      )
    }
  }

  renderWeeklyPreview(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon">{getIcon('talents')}</div>
            <div className="message-icon active">{getIcon('sprint')}</div>
            <div className="message-icon">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 2: Velocity Sprint (Weekly)</h2>
          <p>The second step of the Velocity Sales process is the weekly sprint process. To begin the quarter, you'll select behaviors, skills, and activities for your salespeople to work on every week.</p>
          <p>At the end of each week, you'll receive a report from each of your salespeople and will review their progress on the following Monday. These Monday meetings are a valuable time to provide coaching and guidance on their plan for the following week.</p>
        </div>
      )
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon">{getIcon('talents')}</div>
            <div className="message-icon active">{getIcon('sprint')}</div>
            <div className="message-icon">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 2: Velocity Sprint (Weekly)</h2>
          <p>The second step of the Velocity Sales process is the weekly sprint process. Every week you'll be tasked with working on the behaviors and skills you selected, as well as completing activites and updating your quarterly sales forecast.</p>
          <p>At the end of each week, you'll submit your report to your manager and he or she will review with you the following Monday. These Monday meetings give you dedicated time with your manager to review progress on your goals and discuss your action plan for the following week.</p>
        </div>
      )
    }
  }

  renderDailyPreview(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon">{getIcon('talents')}</div>
            <div className="message-icon">{getIcon('sprint')}</div>
            <div className="message-icon active">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 3: Seven Imperatives (Daily)</h2>
          <p>The last step of the Velocity Sales process is working through the Seven Imperatives process for each deal. Your salespeople should be updating win cards for each opportunity daily.{/*This gives you the ability to know where every deal is at, identify problem areas, and coach your salespeople to victory.*/}</p>
          <p>When your salespeople use the Seven Imperatives framework for each every opportunity, you'll gain valuable insights into deal progress, can quickly identify risks, and will be able to coach and communicate more effectively.</p>
        </div>
      )
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon">{getIcon('talents')}</div>
            <div className="message-icon">{getIcon('sprint')}</div>
            <div className="message-icon active">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 3: Seven Imperatives (Daily)</h2>
          <p>The last step of the Velocity Sales process is working through the Seven Imperatives process for each deal. You should be updating each Seven Imperatives "Win Card" as you make progress on each Opportunity.</p>
          <p>Using the Seven Imperatives framework for each of your opportunities is proven to help you sell more effectively, and gives you a common language for communicating deal progress and risks with leaders and colleagues.</p>
        </div>
      )
    }
  }

  renderInitialMessage(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icon">{getIcon('predictive')}</div>
          <h2>Welcome to Velocity</h2>
          <p>This application is designed to augment your organization's sales training and help you develop your salespeople. Through use of this application and the Velocity Sales process, you should expect to achieve the following in the upcoming months:</p>
          <ul>
            <li>Develop behaviors and skills of your salespeople</li>
            <li>Shorten deal time-to-close and increase win rate</li>
            <li>Improve coaching effectiveness and reception</li>
            <li>More accurate forecasting for your pipeline</li>
            <li>Share a common sales language among other leaders</li>
          </ul>
          <p>We'll get started by going over the basic concepts behind the Velocity Sales system. You and your salespeople will be responsible for completing tasks <b>quarterly, weekly, and daily</b>, so let's review what those tasks look like now.</p>
        </div>
      );
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icon">{getIcon('predictive')}</div>
          <h2>Welcome to Velocity</h2>
          <p>This application is designed to augment your organization's sales training and help you develop as a salesperson. Through this application and the training you will receive from your sales leaders, you should expect to achieve the following in the upcoming months:</p>
          <ul>
            <li>Develop high performing behaviors and sales skills</li>
            <li>Improve deal time-to-close and win rate</li>
            {/*<li>Improved forecasting for your pipeline</li>*/}
            <li>Communicate deals more effectively with colleagues and leaders</li>
            {/*<li>Share a common sales language</li>*/}
          </ul>
          <p>We'll get started by going over the basic concepts behind the Velocity Sales system. You and your manager will be responsible for completing tasks <b>quarterly, weekly, and daily</b>, so let's review what those tasks look like now.</p>
        </div>
      );
    }
  }

  //<p>Also, keep in mind that this application is still in Beta. So if you come across anything not working as intended, please tell us what's up so we can fix it ASAP :)</p>

  renderGetStarted(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icon">{getIcon('rate')}</div>
          <h2>One last thing</h2>
          <p>As you continue to use this application and the Velocity sales process, <b>please reach out to us</b> if you feel like we can help you accomplish these objectives better. You can send us feedback at any time using the <b className="color-pink">Submit Feedback</b> button in the bottom left corner of your screen.</p>
          <p>Next, let's go to your teams page where you can complete initial talent evaluations for your employees, and then work on setting up quarterly goals for their sprints and helping them create action plans.</p>
        </div>
      )
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icon">{getIcon('rate')}</div>
          <h2>One last thing</h2>
          <p>As you continue to use this application and the Velocity sales process, <b>please reach out to us</b> if you feel like we can help you accomplish these objectives better. You can send us feedback at any time using the <b className="color-pink">Submit Feedback</b> button in the bottom left corner of your screen.</p>
          <p>After completing the talent evaluation, your manager should be scheduling a time to meet to review your talent evaluation and make a plan for the quarter. For now, let's get started on that Talent Evaluation...</p>
        </div>
      )
    }
  }

  renderModalActionsForStep(currentStep){

    return(
      <div className="modal-actions">
        {currentStep === 1 &&
          <button onClick={this.next.bind(this)} className="button primary">Next</button>
        }

        {(currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5) &&
          <button onClick={this.prev.bind(this)} className="button left grey-button">Back</button>
        }
        {(currentStep === 2 || currentStep === 3 || currentStep === 4) &&
          <button onClick={this.next.bind(this)} className="button primary">Next</button>
        }
        {currentStep === 5 &&
          <button onClick={this.finishWelcome.bind(this)} className="button primary">Get Started</button>
        }

      </div>
    );
  }

  renderStepProgress(){

    const { currentStep } = this.state;

    return(
      <div className="welcome-progress">
        {_.map([1,2,3,4,5], thisStep => {
          return(
            <div className={`step ${currentStep === thisStep ? 'active' : (currentStep > thisStep ? 'done' : '')}`}></div>
          )
        })}
      </div>
    )
  }

  render(){

    const { currentStep, welcomeComplete } = this.state;

    if(welcomeComplete){
      if(currentUserIsManager()){
        return <Redirect to="/teams" />
      }
      else{
        return <Redirect to="/talents" />
      }
    }

    if(!this.state.visible){
      return null;
    }

    return (
      <div className={`modal welcome full-screen`}>
        <div
          className="modal-container"
          ref={elem => { this.container = elem; }}
        >
          {currentStep === 1 && this.renderInitialMessage()}
          {currentStep === 2 && this.renderQuarterlyPreview()}
          {currentStep === 3 && this.renderWeeklyPreview()}
          {currentStep === 4 && this.renderDailyPreview()}
          {currentStep === 5 && this.renderGetStarted()}

          {this.renderStepProgress()}

          {this.renderModalActionsForStep(currentStep)}
        </div>
      </div>
    )
  }
}

export default WelcomeModal;



// WEBPACK FOOTER //
// ./src/components/modals/welcome.js